export default {
      id: "contact-details-usage",
      viewBox: "0 0 32 26",
      url: __webpack_public_path__ + "sprite.svg#contact-details",
      toString: function () {
        return this.url;
      }
    }